export default {
  title: 'Company data',
  document: 'NIE/CIF',
  reason: 'Company name',
  email: 'Email',
  address: 'Address',
  postalCode: 'Postal Code',
  town: 'Town',
  city: 'City',
  country: 'Country',
  inscription: 'Commercial Register inscription',
  accountAssignedId: 'Accounting Account Code',
  irpf: {
    retention: 'IRPF',
    notSupported: 'No IRPF'
  },
  greenPoint: {
    label: 'Green dot fee',
    notSupported: 'Not Supported',
    included: 'included in the amount',
    brokenDown: 'included in the item'
  },
  subjectTo: 'Subject to the special cash basis regime',
  help: 'Company subject to the Special Cash Criteria Regime, in accordance with Art. 23 of Law 14/2013.',
  ticketbaiRequired: 'Notify TicketBAI',
  headingBizkaia: 'Heading',
  headingListBizkaia: 'Download heading list',
  ticketbaiRequiredHelp: 'Norma Foral 13/2021, of 21 April (Álava). Norma Foral 3/2020, of 6 November (Guipúzcoa), Norma Foral 8/2023, of 22 November (Vizcaya).',
  siiRequired: 'Notify SII (LRFE)',
  siiRequiredHelp: `<br>The settlement period for registration in the SII will correspond to the year and month of the invoice accrual date. <br>The date of issue and of registration with the SII shall be the date of issue of the invoice.`,
  modal: {
    text: 'The data have been updated.'
  },
  terms: 'Terms of service',
  version: {
    title: 'Sistema Efactura',
    front: 'Front release: ',
    core: 'Core release: ',
    back: 'API release: '
  }
}
